import { ShareData } from '../../../models/share.model';
import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { SocialMediaService } from '../../../services/social-media.service';
import { Subscription } from 'rxjs';
import { StartupService } from '../../../services/startup.service';
import { VisualizerService } from '../../../services/visualizer.service';
import { Color } from '../../../models/color.model';
import { environment } from '../../../../environments/environment';
import { AnswerInfoService } from '../../../services/answer-info.service';
import { QuestionTypeEnum } from '../../../models/question-type';
import { QaService } from '../../../services/qa.service';

@Component({
  selector: 'app-share-project',
  templateUrl: './share-project.component.html',
  styleUrls: ['./share-project.component.scss']
})
export class ShareProjectComponent implements OnInit, OnDestroy {
  private subscribtion: Subscription;
  private colorSubscription: Subscription;
  private shareData: ShareData;
  public selectedColor: Color;
  ProjectName: string;
  DefaultProjectImage: string;
  ProjectImage: string;
  MaskImage: string;
  ColorName: string;
  Red: Number;
  Green: Number;
  Blue: Number;
  Opacity: string;
  SocialNetwork: string;
  ShareUrl: string;
  shareUrl: string;

  @ViewChild('SocialShareForm') socialShareForm;

  constructor(
    private socialMediaService: SocialMediaService,
    private visualizerService: VisualizerService,
    private startupService: StartupService,
    private qaService: QaService
  ) { }

  ngOnInit() {
    this.colorSubscription = this.visualizerService.selectedColor.subscribe(c => {
      this.selectedColor = c;
    });
  }

  shouldDisplaySocialShare() {
    if (window.location.href.split('/')[3] === 'fr-ca') {
      return 'none';
    } else {
      return '';
    }
  }

  shareProject(type: string) {
    if (this.selectedColor !== null && this.visualizerService.currentProject !== null) {
      this.shareUrl = `${environment.apiUrl}/${type}`;

      const projectTypeGuid = this.startupService.startupData.QuestionTypes.find(x => x.Name === QuestionTypeEnum.ProjectType).ItemGuid;
      const projectName = this.qaService.answers.selectedAnswers.find(x => x.QuestionType === projectTypeGuid).Title;

      this.ProjectName = projectName;
      this.DefaultProjectImage = this.visualizerService.visualizerData.ProjectImages.find(x => x.IsDefault).ProjectImage;
      this.ProjectImage = this.visualizerService.currentProject.ProjectImage;
      this.MaskImage = this.visualizerService.currentProject.MaskImage;
      this.ColorName = this.selectedColor.Name;
      this.Red = this.selectedColor.R;
      this.Green = this.selectedColor.G;
      this.Blue = this.selectedColor.B;
      this.Opacity = this.selectedColor.OpacityName;
      this.ShareUrl = type === 'facebook' ? environment.facebookUrl : environment.pinterestUrl;

      setTimeout(() => this.socialShareForm.nativeElement.submit(), 100);
    }
  }

  private getShareData() {
    if (this.selectedColor !== null && this.visualizerService.currentProject !== null) {
      //this.shareData = new ShareData({
      //  DefaultProjectImage : this.visualizerService.visualizerData.ProjectImages.find(x=>x.IsDefault).ProjectImage,
      //  ProjectImage: this.visualizerService.currentProject.ProjectImage,
      //  MaskImage: this.visualizerService.currentProject.MaskImage,
      //  ColorName: this.selectedColor.Name,
      //  Red: this.selectedColor.R,
      //  Green: this.selectedColor.G,
      //  Blue: this.selectedColor.B,
      //  Opacity: this.selectedColor.OpacityName
      //});
    }
  }
  private shareSocialMedia(socialMediaName: string) {
    if (this.selectedColor !== null) {
      this.getShareData();
      this.subscribtion = this.socialMediaService.getSocialMediaUrl(this.shareData, socialMediaName).subscribe(response => {
        window.open(response);
      });
    }
  }
  shareFacebook() {
    this.shareSocialMedia('facebook');
  }
  sharePinterest() {
    this.shareSocialMedia('pinterest');
  }
  ngOnDestroy(): void {
    //this.subscribtion.unsubscribe();
    //this.colorSubscription.unsubscribe();
  }
}



// WEBPACK FOOTER //
// ./src/app/components/visualizer/share-project/share-project.component.ts